import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequest } from "../../entity/EntityRequest";

export class DtoRequestsGetRes extends EntityRequest {
  public items: EntityRequest[]  = [];
}
